var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.667 66.6667L109.333 80L93.3335 69.3333V47.1573C85.2055 44.464 75.4455 42.6667 64.0002 42.6667C52.5602 42.6667 42.7948 44.464 34.6668 47.1573V69.3333L18.6668 80L5.3335 66.6667C8.88016 61.3493 18.5548 52.496 34.6668 47.1573C42.7948 44.464 52.5602 42.6667 64.0002 42.6667C75.4455 42.6667 85.2055 44.464 93.3335 47.1573C109.445 52.4907 119.12 61.344 122.667 66.6667Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3335 47.1573C85.2055 44.464 75.4455 42.6667 64.0002 42.6667C52.5602 42.6667 42.7948 44.464 34.6668 47.1573M93.3335 47.1573C109.445 52.4907 119.12 61.344 122.667 66.6667L109.333 80L93.3335 69.3333V47.1573ZM34.6668 47.1573C18.5548 52.4907 8.88016 61.344 5.3335 66.6667L18.6668 80L34.6668 69.3333V47.1573Z",
    stroke: "#1B1B1B",
    strokeWidth: 10.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangUpIcon);
export default __webpack_public_path__ + "static/media/hang-up-icon.469fc1694174eac0ea98a48af7d02b66.svg";
export { ForwardRef as ReactComponent };